import styled from '@emotion/styled';
import { SvyBadge } from '@innovorder/savory';

export const StyledSvyBadge = styled(SvyBadge)`
    font-size: 14px !important;
`;
